import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { sha256Hash } from '../utils';
var sanitizeSources = function sanitizeSources(sources) {
  return sources.map(function (source) {
    var _source$ari;
    return {
      id: (_source$ari = source.ari) !== null && _source$ari !== void 0 ? _source$ari : source.id,
      type: source.type
    };
  });
};
var has3PSources = function has3PSources(sources) {
  return sources.filter(function (source) {
    var _source$ari2, _source$ari3;
    return ((_source$ari2 = source.ari) === null || _source$ari2 === void 0 ? void 0 : _source$ari2.includes('third-party')) || ((_source$ari3 = source.ari) === null || _source$ari3 === void 0 ? void 0 : _source$ari3.includes('graph'));
  });
};

/**
 * Any keys that exactly match an entry in this Set will _NOT_ be sanitized. So be sure that anything
 * you add here will not contain PII or UGC
 */
var ALLOWED_EXTRA_ATTRIBUTES_KEYS = new Set(['contentId', 'readingAidsSessionId', 'fieldType', 'multipleUserResultsShown', 'numAddtlWhoMatches', 'isCuratedDefinition', 'isPrecomputedDefinition', 'editDistance', 'bookmarkId', 'bookmarkState', 'dwellTime',
// from extraAPIAnalyticsAttributes
'message_id', 'conversational_channel_id', 'experience_id', 'user_id',
// from extraAnalyticsAttributes
'experiments', 'featureGates', 'isFullPageSearch', 'has3pProducts', 'is3pSearch', 'mode', 'triggeredBy']);
export var sanitizeExtraAttributes = function sanitizeExtraAttributes(extraAttributes) {
  if (!fg('kd_fe_sanitize_analytics')) {
    return extraAttributes;
  }
  var sanitizedAttributes = {};
  // Sanitize everything except COMMON_ALLOWED_KEYS
  for (var _key in extraAttributes) {
    if (ALLOWED_EXTRA_ATTRIBUTES_KEYS.has(_key)) {
      sanitizedAttributes[_key] = extraAttributes[_key];
    } else {
      // replacing with text because the value has type `any`
      sanitizedAttributes[_key] = '[sanitized]';
    }
  }
  return sanitizedAttributes;
};

// New instrumentation attributes must be added to this function to be included in all the events
export var filterCommonAttributes = function filterCommonAttributes(props) {
  var appliedFilters = props.appliedFilters,
    answerFormat = props.answerFormat,
    answerLength = props.answerLength,
    answerWordCount = props.answerWordCount,
    answerCardType = props.answerCardType,
    followUps = props.followUps,
    sources = props.sources,
    extraAttributes = props.extraAttributes,
    searchSessionId = props.searchSessionId,
    queryHash = props.queryHash,
    baseQueryHash = props.baseQueryHash,
    query = props.query,
    answerString = props.answerString,
    apiSource = props.apiSource,
    brand = props.brand,
    sessionId = props.sessionId;
  return _objectSpread({
    searchSessionId: searchSessionId,
    queryHash: queryHash,
    baseQueryHash: baseQueryHash,
    wordCount: (query.match(/\w+/g) || []).length,
    queryLength: query.length,
    answerHash: sha256Hash(answerString),
    appliedFilters: appliedFilters,
    answerFormat: answerFormat,
    answerLength: answerLength,
    answerWordCount: answerWordCount,
    answerCardType: answerCardType,
    followUpsCount: followUps.length,
    followUpsLength: followUps.map(function (followUp) {
      return followUp.length;
    }),
    has3PSources: has3PSources(sources).length ? true : false,
    sources: sanitizeSources(sources),
    apiSource: apiSource,
    brand: brand,
    sessionId: sessionId
  }, sanitizeExtraAttributes(extraAttributes));
};